import React, { useEffect, useState } from "react";
import { Mail, Linkedin, Github } from "lucide-react";
import "./index.css";
import voxconai from "./voxconai.jpg";

export default function App() {
  const [color, setColor] = useState(false);

  function changeColor() {
    if (window.scrollY >= 90) {
      setColor(true);
    } else {
      setColor(false);
    }
  }

  useEffect(function () {
    window.addEventListener("scroll", changeColor);
  }, []);

  return (
    <div className="gradient">
      <div className="container">
        {/* <Navbar color={color} /> */}
        <Header />
        <Skills />
        <Projects />
        <Footer />
      </div>
    </div>
  );
}

function Navbar({ color }) {
  return (
    <nav className={color ? "navbar navbar-bg" : "navbar"}>
      <p>
        <a href="#skills">Skills</a>
      </p>
      <p>
        <a href="#projects">Projects</a>
      </p>
    </nav>
  );
}

function Header() {
  return (
    <header className="header">
      <div className="headerContent">
        <h1 className="title">
          Hi, I'm <span className="title-name">Rahul Reddy</span>
        </h1>
        <p className="subtitle">CEO | Developer | Technology Leader</p>
        <p className="subtitle2">
          <span className="experience-years">8+ Years</span> Of Experience
        </p>
        <p className="about-me">
          As a CEO and Developer, I combine visionary leadership with hands-on technical expertise to drive innovation and deliver impactful solutions.
          With a strong foundation in AI, web development, and cloud technologies, I’ve built scalable systems that address real-world challenges.
          I lead by example, guiding teams to success while staying deeply involved in the technical aspects of projects. My goal is to create transformative technologies that empower businesses and users alike.
        </p>
        <div className="contactLinks">
          <a
            data-tooltip="Email"
            data-flow="bottom"
            href="mailto:rahul@reddy.ceo"
            className="iconLink"
          >
            <Mail size={24} />
          </a>
          <a
            data-tooltip="LinkedIn"
            data-flow="bottom"
            href="https://www.linkedin.com/in/rahulkasireddy/"
            target="_blank"
            rel="noopener noreferrer"
            className="iconLink"
          >
            <Linkedin size={24} />
          </a>
          <a
            data-tooltip="GitHub"
            data-flow="bottom"
            href="https://github.com/reddyceo"
            target="_blank"
            rel="noopener noreferrer"
            className="iconLink"
          >
            <Github size={24} />
          </a>
        </div>
      </div>
    </header>
  );
}

function Skills() {
  return (
    <section className="section">
      <h2 className="sectionTitle" id="skills" tabIndex={-1}>
        Skills
      </h2>
      <div className="skills">
        {skills.map((skill, index) => (
          <SkillCard key={index} skill={skill} />
        ))}
      </div>
    </section>
  );
}

function SkillCard({ skill }) {
  return (
    <div data-tooltip={skill.title} data-flow="bottom">
      <img
        className="skillCard"
        src={skill.image}
        alt={skill.title}
        loading="lazy"
      />
    </div>
  );
}

function Projects() {
  return (
    <section className="section">
      <h2 className="sectionTitle" id="projects" tabIndex={-1}>
        Projects
      </h2>
      {
        projects.length > 0 ? (
          <div className="projectGrid">
            {projects.map((project, index) => (
              <ProjectCard key={index} project={project} />
            ))}
          </div>
        ) : (
          <div className="projectGrid">
            <p className="about-me">
              Don't wanna disclose as of now, but stay tuned I'll disclose it soon...
            </p>
          </div>
        )
      }
    </section>
  );
}

function ProjectCard({ project }) {
  return (
    <div className={`card project${project.id}`}>
      <img
        src={project.image}
        alt={project.title}
        className="cardImage"
        loading="lazy"
      />
      <div className="cardContent">
        <h3 className="cardTitle">{project.title}</h3>
        <p className="cardDescription">{project.description}</p>
        <p className="cardTech">
          Technologies: {project.technologies.join(", ")}
        </p>
        <ul className="featureList">
          {project.features.map((feature, index) => (
            <li key={index} className="featureItem">
              {feature.emoji} {feature.text}
            </li>
          ))}
        </ul>
        <div className="buttons">
          {
            project.link ? (
              <a
                href={project.link}
                target="_blank"
                rel="noopener noreferrer"
                className="button"
              >
                Visit ↗️
              </a>
            ) : null
          }
          {
            project.github ? (
              <a
                href={project.github}
                target="_blank"
                rel="noopener noreferrer"
                className="button"
              >
                GitHub Repo ↗️
              </a>
            ) : null
          }
        </div>
      </div>
    </div>
  );
}

function Footer() {
  return (
    <section className="section">
      <p className="about-me">
        {/* Thank you */}
        {/* {" "} */}
        {/* <span data-tooltip="Have a good day!" data-flow="bottom">
          😀
        </span> */}
      </p>
    </section>
  );
}

const skills = [
  {
    title: "Python",
    image:
      "https://upload.wikimedia.org/wikipedia/commons/1/1f/Python_logo_01.svg",
  },
  {
    title: "PHP",
    image:
      "https://upload.wikimedia.org/wikipedia/commons/2/27/PHP-logo.svg",
  },
  {
    title: "Java",
    image:
      "https://upload.wikimedia.org/wikipedia/en/3/30/Java_programming_language_logo.svg",
  },
  {
    title: "C#",
    image:
      "https://upload.wikimedia.org/wikipedia/commons/d/d2/C_Sharp_Logo_2023.svg",
  },
  {
    title: "Swift",
    image:
      "https://upload.wikimedia.org/wikipedia/commons/9/9d/Swift_logo.svg",
  },
  {
    title: "Rust",
    image:
      "https://upload.wikimedia.org/wikipedia/commons/d/d5/Rust_programming_language_black_logo.svg",
  },
  {
    title: "Ruby",
    image:
      "https://upload.wikimedia.org/wikipedia/commons/7/73/Ruby_logo.svg",
  },
  {
    title: "Go",
    image:
      "https://upload.wikimedia.org/wikipedia/commons/0/05/Go_Logo_Blue.svg",
  },
  {
    title: "Kotlin",
    image:
      "https://upload.wikimedia.org/wikipedia/commons/1/11/Kotlin_logo_2021.svg",
  },
  {
    title: "Dart",
    image:
      "https://upload.wikimedia.org/wikipedia/commons/f/fe/Dart_programming_language_logo.svg",
  },
  {
    title: "JavaScript",
    image:
      "https://upload.wikimedia.org/wikipedia/commons/6/6a/JavaScript-logo.png",
  },
  {
    title: "TypeScript",
    image:
      "https://upload.wikimedia.org/wikipedia/commons/f/f5/Typescript.svg",
  },
  {
    title: "Node.js",
    image:
      "https://upload.wikimedia.org/wikipedia/commons/d/d9/Node.js_logo.svg",
  },
  {
    title: "React.js & React Native",
    image:
      "https://upload.wikimedia.org/wikipedia/commons/a/a7/React-icon.svg",
  },
  {
    title: "Angular",
    image:
      "https://upload.wikimedia.org/wikipedia/commons/0/07/Angular_Logo_SVG.svg",
  },
  {
    title: "MongoDB",
    image:
      "https://upload.wikimedia.org/wikipedia/en/5/5a/MongoDB_Fores-Green.svg",
  },
  {
    title: "MySQL",
    image:
      "https://upload.wikimedia.org/wikipedia/en/d/dd/MySQL_logo.svg",
  },
  {
    title: "PostgreSQL",
    image:
      "https://upload.wikimedia.org/wikipedia/commons/2/29/Postgresql_elephant.svg",
  },
  {
    title: "Redis",
    image:
      "https://upload.wikimedia.org/wikipedia/commons/e/ee/Redis_logo.svg",
  },
  {
    title: "GraphQL",
    image:
      "https://upload.wikimedia.org/wikipedia/commons/1/17/GraphQL_Logo.svg",
  },
];

const projects = [
  // {
  //   id: 1,
  //   title: "Voxcon AI",
  //   image: voxconai,
  //   technologies: ["HTML", "CSS", "JavaScript", "React.js", "Node.js", "MongoDB"],
  //   description: "Revolutionizing communication with intelligent AI-driven voice calls and instant responses.",
  //   link: "https://www.voxconai.com/",
  //   features: [

  //     { text: "AI Voice Calls", emoji: "📞" },
  //     { text: "Intelligent Responses", emoji: "🤖" },
  //     { text: "Real-Time Communication", emoji: "⚡" },
  //     { text: "Seamless Integration", emoji: "🌐" },
  //     { text: "Smart Voice Processing", emoji: "🧠" },
  //     { text: "Enhanced Productivity", emoji: "🚀" },
  //     { text: "Precision AI Handling", emoji: "🎯" },
  //     { text: "Next-Gen Interaction", emoji: "💡" },
  //   ],
  // },
];
